import { tableFrCATranslations } from "../components/table/_lang/fr-CA";
import { draftFrCATranslations } from "../hooks/_lang/fr-CA";
import type { RayaLucariaTranslationKey } from "./en-US";

export const rayaLucariaFrCA: Record<RayaLucariaTranslationKey, string> = {
  ...tableFrCATranslations,
  ...draftFrCATranslations,
  apply: "Appliquer",
  cancel: "Annuler",
  close: "Fermer",
  clear: "Effacer",
  confirm: "Confirmer",
  filter: "Filtrer",
  filterValue: "Valeur du filtre",
  expandMenu: "Développer le menu",
  collapseMenu: "Réduire le menu",
  openMenu: "Ouvrir le menu",
  mainNavigation: "Navigation principale",
  secondaryNavigation: "Navigation secondaire",
  navigationMenu: "Menu de navigation",
};
